export const text = (text: string) => `<span>${text}</span>`
